import { render } from "./BookThumbnail.vue?vue&type=template&id=72389cdf"
import script from "./BookThumbnail.vue?vue&type=script&lang=js"
export * from "./BookThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__